<template>
  <div class="cases-container" :class="{ 'is-bg-img': tabType === '1' }">
    <div class="weapon-cases-main-width">
      <Tabs class="switch-tabs" :tabs="tabsOptions" v-model="tabType" />
      <div class="latest-tab" v-show="tabType === '1'">
        <LatestTab :list="latestList" />
      </div>
      <div class="overview-tab" v-show="tabType === '2'">
        <OverviewTab :list="overviewList" />
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from "./components/tabs";
import LatestTab from "./components/latest";
import OverviewTab from "./components/overview";
import responsiveMixin from "@/mixins/responsive";

export default {
  mixins: [responsiveMixin],
  components: { Tabs, LatestTab, OverviewTab },
  data() {
    return {
      tabType: "1",
      tabsOptions: [{
        value: "1",
        label: "LATEST SEASON"
      }, {
        value: "2",
        label: "WEAPON CASES OVERVIEW"
      }],
      latestList: [],
      overviewList: []
    };
  },
  props: {
    casesList: {
      type: Array,
      default: () => []
    }
  },
  mounted() { },
  beforeDestroy() { },
  methods: {
    handlerCategory(list) {
      // 拆分最新赛季和历史宝箱
      this.latestList = list.filter(item => item.display === 1 && item.display_as_latest === 1).sort((a, b) => b.order - a.order);
      this.overviewList = list.filter(item => item.display === 1 && item.display_as_latest === 0).sort((a, b) => b.order - a.order);

      // 对武器排序
      this.latestList.forEach(item => {
        item.weapons.sort((a, b) => b.order - a.order);
        item.weapons.forEach((weapon, index) => {
          const order = String(weapon.order);
          weapon.id = index + "-" + order;
        });
      });
      this.overviewList.forEach(item => {
        item.weapons.sort((a, b) => b.order - a.order);
        item.weapons.forEach((weapon, index) => {
          const order = String(weapon.order);
          weapon.id = index + "-" + order;
        });
      });
    }
  },
  watch: {
    casesList: {
      handler(newValue) {
        if (newValue && newValue.length) {
          this.handlerCategory(newValue);
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
